import { Skeleton, Stack } from '@mantine/core';

export const LoadingSkeleton = () => {
  return (
    <Stack>
      <Skeleton height={48} radius="md" />
      <Skeleton height={48} radius="md" />
      <Skeleton height={48} radius="md" />
    </Stack>
  );
};
